import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "card-container"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "drama-info"
};
const _hoisted_4 = {
  key: 0,
  class: "user-row-container"
};
const _hoisted_5 = {
  class: "stage-text"
};
const _hoisted_6 = {
  class: "role-container"
};
const _hoisted_7 = {
  class: "role-nickname"
};
const _hoisted_8 = {
  key: 1,
  class: "user-row-container"
};
const _hoisted_9 = {
  class: "second-info"
};
const _hoisted_10 = {
  key: 2,
  class: "operation-bar"
};
const _hoisted_11 = {
  key: 3,
  class: "operation-bar"
};
import { ElButton, ElImage } from 'element-plus';
import { getPerformanceDesc } from '@/tools/utils';
import store from '@/store';
import router from '@/router';
export default {
  __name: 'ApplicationRecordCard',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  emits: ['update'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // functions

    const getApplicationTitle = () => {
      if (props.data.position === 0) {
        return '演职员申请';
      } else if (props.data.position === 1) {
        return '观众席申请';
      }

      return '异常申请';
    };

    const getApplicationStatus = () => {
      switch (props.data.status) {
        case 0:
          return '申请中';

        case 1:
          return '已驳回';

        case 2:
          return '已许可';

        case 3:
          return '已取消';

        case 4:
          return '舞台关闭';

        default:
          return '';
      }
    };

    const cancelApplication = () => {
      if (!props.data) return;
      emits('update', props.data.id);
    };

    const entryStage = () => {
      store.commit('update_stage', {
        'stage_id': props.data.stage.stage_id
      });
      router.push(`/stage`);
    };

    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      const _component_el_col = _resolveComponent("el-col");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_col, {
        span: 15
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          class: "stage-container"
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: __props.data.stage.stage_image,
            draggable: "false",
            alt: "",
            class: "stage-image"
          }, null, 8, _hoisted_2), _createElementVNode("text", _hoisted_3, " 「" + _toDisplayString(__props.data.stage.drama) + "」 ", 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 9,
        class: "application-container"
      }, {
        default: _withCtx(() => [_createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(getApplicationTitle()), 1), _createTextVNode("  |  " + _toDisplayString(__props.data.stage.stage_name), 1)]), _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), __props.data.position === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_cache[0] || (_cache[0] = _createTextVNode(" 向舞台 “", -1)), _createElementVNode("b", null, _toDisplayString(__props.data.stage.stage_name), 1), _cache[1] || (_cache[1] = _createTextVNode("” 提交了角色  ", -1))]), _createElementVNode("div", _hoisted_6, [_createVNode(_unref(ElImage), {
          src: __props.data.role.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"]), _createElementVNode("span", _hoisted_7, _toDisplayString(__props.data.role.nickname) + "  ", 1)])])) : __props.data.position === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("text", null, [_cache[2] || (_cache[2] = _createTextVNode("向舞台 “", -1)), _createElementVNode("b", null, _toDisplayString(__props.data.stage.stage_name), 1), _cache[3] || (_cache[3] = _createTextVNode("” 申请了一个观众席位", -1))])])) : _createCommentVNode("", true), _createElementVNode("text", _hoisted_9, " [链接者：" + _toDisplayString(__props.data.anchor.name) + "]   [" + _toDisplayString(`${__props.data.stage.start_date} ~ ${__props.data.stage.end_date}`) + "]   [舞台募集中]   [演出" + _toDisplayString(_unref(getPerformanceDesc)(__props.data.stage.status)) + "] ", 1), __props.data.stage.status === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [__props.data.status === 2 && __props.data.stage.available ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 0,
          onClick: entryStage
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" 进入舞台 ", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [[0, 2].includes(__props.data.status) ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 0,
          class: _normalizeClass(__props.data.status === 2 ? 'withdraw' : 'cancel'),
          onClick: cancelApplication
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.data.status === 2 ? '撤除申请' : '取消申请'), 1)]),
          _: 1
        }, 8, ["class"])) : _createCommentVNode("", true), __props.data.status === 2 ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 1,
          onClick: entryStage
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 进入舞台 ", -1)]))]),
          _: 1
        })) : (_openBlock(), _createElementBlock("text", {
          key: 2,
          class: _normalizeClass(["application-status", `status-${__props.data.status}`])
        }, "   " + _toDisplayString(getApplicationStatus()) + "   ", 3))]))]),
        _: 1
      })]);
    };
  }

};